import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicLayoutComponent } from '../layout/public-layout/public-layout.component';
import {  OpenIdLoginComponent } from './openIdLogin.component';

const routes: Routes = [
  {
    path: 'openIdLogin',
    component: PublicLayoutComponent,
    children: [
      { path: '', component: OpenIdLoginComponent },
    ]
  },
  {
    path: 'openIdLogin',
    component: PublicLayoutComponent,
    children: [
      { path: ':id', component: OpenIdLoginComponent },
    ]

  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OpenIdLoginRoutingModule { }
